import * as React from "react";
import { Routes, Route, useNavigate, useLocation, Link, useMatch } from "react-router-dom";
import { Anchor, Box, Button, Grommet, Image, ResponsiveContext, Page, Text, Stack } from "grommet";
import { Account, GetCurrentLogin, usePermission, useUser } from "../account/AccountStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import StyledModal from "../components/StyledModel";
import { AppBarItem, NavigationButton } from "../components/NavigationButton";

const AdminNavigation = () => {
    return (
        <>
            <Box direction="row" wrap gap="medium" pad="medium" align="center" justify="center">
                <NavigationButton key={"stats"} href={"stats"} text="Stats"></NavigationButton>
                <NavigationButton key={"billing"} href={"billing"} text="Billing"></NavigationButton>
                <NavigationButton key={"discord"} href={"discord"} text="Discord"></NavigationButton>
                <NavigationButton key={"content"} href={"content"} text="Content"></NavigationButton>
                <NavigationButton key={"badges"} href={"badges"} text="Badges"></NavigationButton>
                <NavigationButton key={"maps"} href={"maps"} text="Maps"></NavigationButton>
                <NavigationButton key={"games"} href={"games"} text="Games"></NavigationButton>
                <NavigationButton key={"agents"} href={"agents"} text="Agents"></NavigationButton>
            </Box>
        </>
    );
};

export default AdminNavigation;
